<script lang="ts">
  export let message: string = '';
</script>

<div class="tooltip" role="tooltip">
  <div class="tooltipTitle">
    {@html message}
  </div>
  <div class="tooltipArrow" />
</div>

<style lang="scss">
  .tooltip {
    position: relative;
    min-height: 40px;
    width: 100%;
    padding: 8px 16px;
    color: var(--color-white);
    border-radius: 3px;
    font-size: var(--font-size-14);
    line-height: var(--line-height-24);
    font-weight: var(--font-weight-medium);
    filter: drop-shadow(0 2px 10px var(--color-drop-shadow));
    z-index: 100;
    pointer-events: none;

    margin-top: var(--space-10);
    transform: translateY(calc(-1 * var(--tooltip-arrow-size)));

    background-color: var(--color-red);

    .tooltipArrow {
      pointer-events: none;
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(calc(-1 * var(--space-10)));
      border: var(--space-10) solid var(--color-red);
      top: calc(-1 * (var(--space-20)));
      border-top-color: transparent;
      border-right-color: transparent;
      border-left-color: transparent;
    }
  }
</style>
